module.exports = __webpack_public_path__ + "img/button-sub.45ad4f03.png";